//this the base URL of the API
// export const API_URL = "http://192.168.1.14:5003";
export const API_URL = "https://ecom.squbix.com";
